import { ID, WoosatTelecomResponse, Response } from '../../../../../_metronic/helpers'

export type PaymentMethod = {
  id?: any
  method_name?: string
  account_details?: string
  account_image?: string
  status?: any
}

export type PaymentMethodsQueryResponse = WoosatTelecomResponse<PaymentMethod[]>

export const initialPaymentMethod: PaymentMethod = {
  id: '',
  method_name: '',
  account_details: '',
  account_image: '',
  status: 1, // Default to active
}
